export const tennisCourts = {
  1: {
    "surface-reserve": 4,
  },
  2: {
    "surface-reserve": 5,
  },
  3: {
    "surface-reserve": 6,
  },
  4: {
    "surface-reserve": 7,
  },
  5: {
    "surface-reserve": 8,
  },
  6: {
    "surface-reserve": 9,
  },
  9: {
    "surface-reserve": 17,
  },
  10: {
    "surface-reserve": 10,
  },
  11: {
    "surface-reserve": 11,
  },
  12: {
    "surface-reserve": 12,
  },
  13: {
    "surface-reserve": 13,
  },
  14: {
    "surface-reserve": 14,
  },
  15: {
    "surface-reserve": 16,
  },
  16: {
    "surface-reserve": 15,
  },
  17: {
    "surface-reserve": 18,
  },
};

export const pickleballCourts = {
  1: {
    "surface-reserve": 4,
  },
  2: {
    "surface-reserve": 5,
  },
  3: {
    "surface-reserve": 6,
  },
  4: {
    "surface-reserve": 7,
  },
  5: {
    "surface-reserve": 8,
  },
  6: {
    "surface-reserve": 9,
  },
};

export const tennisLocationReserve = 1;
export const pickleballLocationReserve = 43;
